import type {
  CodeableConcept,
  Practitioner,
  Reference,
  Task,
} from '@medplum/fhirtypes'
import { addBusinessDays, isFuture, min, subBusinessDays } from 'date-fns'
import type { Order } from '#src/models/orders/index.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import { StandardTask } from '#src/models/tasks/standard/standardTask.ts'
import { Role } from '#src/roles.ts'
import { now } from '#src/utils.ts'

export class ScheduleAppointmentTask extends StandardTask {
  static defaultRoles = [Role.MA, Role.LVN, Role.OT, Role.PT, Role.SW, Role.RD]
  static useServiceCategoryRoles = true

  constructor({
    order,
    owner,
    ...rest
  }: Partial<Omit<Task, 'resourceType'>> & {
    order: Order
    owner?: Reference<Practitioner>
  }) {
    super({
      code: ScheduleAppointmentTask.code,
      priority: order.urgent ? 'stat' : 'urgent',
      focus: order.reference,
      requester: order.signedBy,
      owner,
      ...rest,
    })
    this.title = 'Schedule Appointment'
    this.description = 'Schedule an appointment'
    this.state = 'todo'
    this.participant = order.participant
    let dueOn = order.urgent
      ? addBusinessDays(now(), 1).toISOString()
      : addBusinessDays(now(), 5).toISOString()
    if (order.collectionDate && isFuture(order.collectionDate)) {
      dueOn = subBusinessDays(order.collectionDate, 2).toISOString()
    }

    if (order.dueDate) {
      dueOn = min([dueOn, order.dueDate]).toISOString()
    }

    this.dueOn = dueOn
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.SCHEDULE_APPOINTMENT
  }
}
